var map = {
	"./bg0.png": 7082,
	"./bg1.png": 1535,
	"./cishutongji.png": 4495,
	"./guanliyuan.png": 1610,
	"./hjjc_logo.png": 9861,
	"./logo.png": 4427,
	"./yujingtitle.png": 9085,
	"./一般.png": 9754,
	"./严重.png": 173,
	"./光合辐射.png": 3272,
	"./光照强度.png": 1334,
	"./光照强度副本.png": 5529,
	"./刮风.png": 9775,
	"./基地10.png": 2631,
	"./基地2.png": 2702,
	"./基地3.png": 3732,
	"./基地4.png": 908,
	"./基地6.png": 9446,
	"./基地7.png": 9518,
	"./天气图标_中雨.png": 3985,
	"./天气图标_中雪.png": 4502,
	"./天气图标_多云.png": 3430,
	"./天气图标_大雨.png": 713,
	"./天气图标_晴.png": 8073,
	"./天气图标_暴雨.png": 4203,
	"./天气图标_阴.png": 1760,
	"./小雨.png": 5383,
	"./已切换.png": 4589,
	"./正常.png": 1655,
	"./水位.png": 3123,
	"./空气压力.png": 2019,
	"./空气压力副本.png": 7669,
	"./空气温度.png": 8839,
	"./空气湿度.png": 3593,
	"./站号未选中.png": 5211,
	"./站号选中.png": 5503,
	"./蓝色按钮.png": 8234,
	"./较重.png": 480,
	"./降雨量.png": 858,
	"./风速.png": 7177,
	"./默认.png": 7623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;